import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';

import {
  loadDashboardOrdersFail,
  loadDashboardOrdersRequested,
  loadDashboardOrdersSuccess,
  loadDashboardOrdersStatusFail,
  loadDashboardOrdersStatusRequested,
  loadDashboardOrdersStatusSuccess,
  loadDashboardProductCountFail,
  loadDashboardProductCountRequested,
  loadDashboardProductCountSuccess,
  loadDashboardReviewCountFail,
  loadDashboardReviewCountRequested,
  loadDashboardReviewCountSuccess,
  loadDashboardInquiryCountFail,
  loadDashboardInquiryCountRequested,
  loadDashboardInquiryCountSuccess,
  loadDashboardCustomerCountFail,
  loadDashboardCustomerCountRequested,
  loadDashboardCustomerCountSuccess,
} from './dashboardSlice';
import toast from 'react-hot-toast';

export function* loadOrdersDashboardEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-order-details?Id=${action.payload.id}`
    );

    if (data?.succeeded) {
      yield put(loadDashboardOrdersSuccess(data));
      yield call(loadDashboardStatusCountEffect, {
        payload: null,
        type: '',
      });
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(loadDashboardOrdersFail(error.message));
  }
}

//status count
export function* loadDashboardStatusCountEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(axiosInstance.get, `${apiURL}/status-count`);
    yield put(loadDashboardOrdersStatusSuccess(data));
  } catch (error: any) {
    yield put(loadDashboardOrdersStatusFail(error.message));
  }
}

// product count
export function* loadDashboardProductCountEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-products-count`
    );
    yield put(loadDashboardProductCountSuccess(data));
  } catch (error: any) {
    yield put(loadDashboardProductCountFail(error.message));
  }
}

//review count
export function* loadDashboardReviewCountEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-review-count`
    );
    yield put(loadDashboardReviewCountSuccess(data));
  } catch (error: any) {
    yield put(loadDashboardReviewCountFail(error.message));
  }
}

//inquiry count
export function* loadDashboardInquiryCountEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-inquiry-count`
    );
    yield put(loadDashboardInquiryCountSuccess(data));
  } catch (error: any) {
    yield put(loadDashboardInquiryCountFail(error.message));
  }
}

//customer count
export function* loadDashboardCustomerCountEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-customer-count`
    );
    yield put(loadDashboardCustomerCountSuccess(data));
  } catch (error: any) {
    yield put(loadDashboardCustomerCountFail(error.message));
  }
}

export function* dashboardSaga(): Generator<any, void, any> {
  yield takeEvery(loadDashboardOrdersRequested, loadOrdersDashboardEffect);
  yield takeEvery(
    loadDashboardOrdersStatusRequested,
    loadDashboardStatusCountEffect
  );
  yield takeEvery(
    loadDashboardProductCountRequested,
    loadDashboardProductCountEffect
  );

  yield takeEvery(
    loadDashboardReviewCountRequested,
    loadDashboardReviewCountEffect
  );
  yield takeEvery(
    loadDashboardInquiryCountRequested,
    loadDashboardInquiryCountEffect
  );
  yield takeEvery(
    loadDashboardCustomerCountRequested,
    loadDashboardCustomerCountEffect
  );
}
